"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    loanProductSlug: v4_1.z.string().optional().describe('Loan product slug'),
    creditFacilitySlug: v4_1.z
        .string()
        .optional()
        .describe('If you are referencing a table that is part of a credit facility, you can specify the credit facility slug here.'),
    query: v4_1.z.string().describe('Query to execute.'),
    bindings: v4_1.z
        .array(v4_1.z.string())
        .describe('Bindings to use in the query. These are formulas (if starting with =) that are evaluated to get the final value. Any placeholders (?) in the query will be replaced with these bindings.'),
});
exports.nodeType = 'file_dataLakeTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'dataLakeTape';
//# sourceMappingURL=types.js.map